export const state = () => ({
    contentFeed: {},
    contentFeeds: [],
    contentFeedsLoading: false,
    selectedContentFeed: {},
});
